import { Permission } from '@idc-forms/permissions'
import type { RouteObject } from 'react-router'
import { Navigate } from 'react-router'
import { PATHS } from '@/app/router/routes'
import { ProtectedRoute } from '@/shared/components/protected-route'

/** Dashboard de revalidación — vista de gestión (métricas del PRD §10). */
export const revalidationRoutes: RouteObject[] = [
  {
    element: <ProtectedRoute permission={Permission.ReadAllClients} />,
    children: [
      {
        index: true,
        element: <Navigate to={`${PATHS.admin.clients.root}?modo=revalidacion`} replace />
      }
    ]
  }
]
